import axios from "axios";

//get setting
 export async function validateVatNumber(countryCode, vatNumber) {
    var request = await axios.post("https://services.mobiapi.de/validate-vat-number", {
      countryCode: countryCode,
      vatNumber: vatNumber,
    });
    return request.data;
  }